import React from 'react';
import { RsNumberInput } from 'components/Rsuite/Input';
import { FormikErrors } from 'formik';
import { Form } from 'rsuite';
import { useBidRange } from '../../Hooks/useBidRange';

interface Iprops {
  values: any;
  currency: string;
  suggestCpc: number[];
  errors: FormikErrors<any>;
  onBidPriceChange: (bidPrice: number) => void;
}

const BidPrice: React.FC<Iprops> = ({
  values,
  suggestCpc,
  errors,
  currency = '',
  onBidPriceChange,
}) => {
  const bidRange = useBidRange();

  const handleChangeBidPrice = (bidPrice) => {
    onBidPriceChange(bidPrice);
  };

  return (
    <div className='flex flex-col gap-2'>
      <RsNumberInput
        prefix='NTD'
        num={values.basic.bidPrice}
        onChange={(bidPrice) => handleChangeBidPrice(bidPrice)}
        placeholder='請輸入金額'
      />
      <Form.ErrorMessage
        show={(errors.basic as { bidPrice?: string })?.bidPrice !== undefined}
        placement='topEnd'
      >
        {/* 這邊這樣寫不好, 根本解決方法是在 initialvalues 定義完整型別 */}
        {(errors.basic as { bidPrice?: string })?.bidPrice}
      </Form.ErrorMessage>

      <Form.HelpText className='text-nowrap'>
        建議出價 NTD {suggestCpc[0]} 元 - NTD {suggestCpc[1]}{' '}
        元，以提升廣告曝光機會
        <br />
        此建議出價反映近期市場競爭參考值，僅供參考，請依您的期望成效與實際投放狀況調整出價
      </Form.HelpText>
    </div>
  );
};

export default BidPrice;
